import api from './api';
import { MovimentacaoCaixaRequestDTO, MovimentacaoCaixaResponseDTO } from '../types/caixa';
import { caixaService } from './caixaService';
import { ApiResponse, PageResponse } from '../types/api';

export async function criarMovimentacaoCaixa(input: MovimentacaoCaixaRequestDTO) {
  // Usa a rota correta de criação de movimentação
  return api.post<MovimentacaoCaixaResponseDTO>('/v1/movimentacoes-caixa', input);
}

export async function criarAberturaDeCaixa(valor: number, opts?: { descricao?: string; observacoes?: string; data?: string; usuarioId?: string; caixaId?: string; }) {
  const hoje = new Date().toISOString().slice(0, 10);
  // Resolve código do tipo de movimentação via endpoint oficial
  const tiposResp = await caixaService.getMovementTypes();
  const tipos = tiposResp.data ?? [];
  // Busca um tipo que contenha 'ABERTURA' no código (case-insensitive)
  const aberturaCodigo = tipos.find((t: string) => /abertura/i.test(String(t)));
  const tipoMov = aberturaCodigo || 'ABERTURA_CAIXA';

  const body: MovimentacaoCaixaRequestDTO = {
    tipoMovimentacao: tipoMov,
    valor: Number(valor || 0),
    dataMovimentacao: opts?.data ?? hoje,
    descricao: opts?.descricao ?? 'Abertura de Caixa',
    observacoes: opts?.observacoes,
    usuarioId: opts?.usuarioId,
    caixaId: opts?.caixaId,
  };
  return criarMovimentacaoCaixa(body);
}

export async function listarMovimentacoesPorCaixa(params: {
  caixaId: string;
  page?: number;
  size?: number;
  sort?: string;
  tipoMovimentacao?: string;
}): Promise<ApiResponse<PageResponse<MovimentacaoCaixaResponseDTO>>> {
  const searchParams = new URLSearchParams();
  searchParams.append('caixaId', params.caixaId);
  if (params.page !== undefined) searchParams.append('page', String(params.page));
  if (params.size !== undefined) searchParams.append('size', String(params.size));
  if (params.sort) searchParams.append('sort', params.sort);
  if (params.tipoMovimentacao) searchParams.append('tipoMovimentacao', params.tipoMovimentacao);

  const url = `/v1/movimentacoes-caixa?${searchParams.toString()}`;
  const response = await api.get<ApiResponse<PageResponse<MovimentacaoCaixaResponseDTO>>>(url);
  
  return {
    success: true,
    message: 'Movimentações carregadas com sucesso',
    data: response.data?.data ?? response.data,
    timestamp: new Date().toISOString(),
  };
}